<template>
    <div>
        <table>
            <pt-message-table-item label="返现金额">
               <wt-input placeholder="请输入返现金额" v-model="cashBackAmount" :class="$style['flash-borrow-amount']"  data-vv-as="返现金额" type="number" v-validate="'required|decimal:2|min_value:0'">
                <el-button slot="append">元</el-button>
              </wt-input>
            </pt-message-table-item>
        </table>
         <div class="button-div no-margin-left">
            <el-button type="primary" @click="flashBorrowAudit" :loading="loading">审核通过</el-button>
             <el-button type="primary" @click="cancel" plain>取消</el-button>
        </div>
    </div>
</template>
<script>
import { cashCount } from '@/utils/formUtils'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      cashBackAmount: 2200,
      loading: false
    }
  },
  methods: {
    cancel () {
      this.$emit('closeDialog')
    },
    flashBorrowAudit () {
      this.validate().then(res => {
        let form = {
          cashBackAmount: cashCount(this.cashBackAmount),
          flashBorrowId: this.id
        }
        this.loading = true
        this.$store.dispatch('flashBorrowAudit', form).then(res => {
          this.$message.success('银行分期返惠审核成功')
          this.loading = false
          this.$emit('closeDialog', true)
        }).catch(err => {
          this.loading = false
          this.$message.error(err || '银行分期返惠审核失败')
        })
      })
    }
  }
}
</script>
<style module lang="less">
.flash-borrow-amount{
     max-width:300px;
  margin-right: 30px;
}
</style>
<style lang="less">
.no-margin-left{
    padding-left:0
}
</style>
